import Accordion from './accordion/accordion.vue'
import CardNews from './card-news/card-news.vue'
import Heading from './heading/heading.vue'
import HeadquarterItem from './headquarter-item/headquarter-item.vue'
import LinkList from './link-list/link-list.vue'
import NtDropDown from './nt-dropdown/nt-dropdown.vue'
import NtCheck from './nt-form-fields/nt-form-checkgroup/form-check.vue'
import NtFormCheckGroup from './nt-form-fields/nt-form-checkgroup/nt-form-checkgroup.vue'
import NtFormCheckLink from './nt-form-fields/nt-form-checklink/nt-form-checklink.vue'
import NtFormCustomResult from './nt-form-fields/nt-form-customresult/nt-form-customresult.vue'
import NtFormInput from './nt-form-fields/nt-form-input/nt-form-input.vue'
import NtFormRadio from './nt-form-fields/nt-form-radiogroup/nt-form-radio.vue'
import NtFormRadioGroup from './nt-form-fields/nt-form-radiogroup/nt-form-radiogroup.vue'
import NtFormRichText from './nt-form-fields/nt-form-richtext/nt-form-richtext.vue'
import NtFormSelect from './nt-form-fields/nt-form-select-2/nt-form-select-2.vue'
import NtFormSubmit from './nt-form-fields/nt-form-submit/nt-form-submit.vue'
import NtFormTextarea from './nt-form-fields/nt-form-textarea/form-textarea.vue'
import NtFile from './nt-form-fields/nt-form-uploader/uploader-file.vue'
import NtUploader from './nt-form-fields/nt-form-uploader/uploader.vue'
import NtQuote from './nt-quote/nt-quote.vue'
import Onetrust from './onetrust/onetrust.vue'
import OnetrustBlocker from './onetrust/onetrust-blocker.vue'
import Paginator from './paginator/paginator.vue'
import Press from './press'
import SafetyDataSheet from './safety-datasheet-v2/safety-datasheet-v2.vue'
import SearchInput from './search-input/search-input.vue'
import ShareOverlay from './share-overlay/share-overlay.vue'
import ShareThis from './share-this/share-this.vue'
import SmartCard from './smart-card/smart-card.vue'
import SmartQuote from './smart-quote/smart-quote.vue'
import SocialMediaCard from './social-media-card/social-media-card.vue'

export default [
  Accordion,
  CardNews,
  Heading,
  HeadquarterItem,
  LinkList,
  NtDropDown,
  NtCheck,
  NtFormCheckGroup,
  NtFormCheckLink,
  NtFormCustomResult,
  NtFormInput,
  NtFormRadio,
  NtFormRadioGroup,
  NtFormRichText,
  NtFormSelect,
  NtFormSubmit,
  NtFormTextarea,
  NtFile,
  NtUploader,
  NtQuote,
  Onetrust,
  OnetrustBlocker,
  Paginator,
  Press,
  SafetyDataSheet,
  SearchInput,
  ShareOverlay,
  ShareThis,
  SmartCard,
  SmartQuote,
  SocialMediaCard
]
